export default import.meta.ROLLDOWN_FILE_URL_mYjlld9yTZoInsyi6McoVQ